import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut } from "lucide-react";

const ROLE_LABELS = {
  direction: "Direction",
  assoc_admin: "Professeur admin associé",
  teacher: "Professeur",
};

const homePathFor = (user) => {
  if (!user) return "/";
  return user.role === "direction" ? "/admin" : "/teacher";
};

export function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="bg-[var(--cream)] border-b border-[var(--parchment-2)] sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to={homePathFor(user)} className="flex items-center gap-3" data-testid="header-logo-link">
          <img
            src="/lafayette-logo.jpg"
            alt="Lafayette Progress"
            className="h-10 w-10 object-contain rounded-full"
          />
          <span className="font-serif-display text-xl font-semibold text-[var(--maroon)] tracking-tight">LAFAYETTE PROGRESS</span>
        </Link>
        {user && (
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium" data-testid="header-user-name">{user.name}</div>
              <div className="eyebrow" data-testid="header-user-role">
                {ROLE_LABELS[user.role] || "Professeur"}
              </div>
            </div>
            <button
              onClick={doLogout}
              className="btn-secondary !py-2 !px-4 flex items-center gap-2"
              data-testid="logout-btn"
            >
              <LogOut size={16} /> Déconnexion
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
